import { fetchRequestPrev } from "@providers/conect_prev";

const verServApi = async ( data ) => {

  try {
    const url = `integrations/previplan/consultar-especialidades`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const verValServApi = async ( data ) => {

  try {
    const url = `integrations/previplan/consultar-servicios`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verServApi, verValServApi };
